<template>
  <!--begin::Dashboard-->
  <div class="row">
    <div
      class="col-md-12 col-lg-12 aos-init aos-animate content d-flex flex-column mt-1 mb-5 mx-auto"
      data-aos="fade-up"
      data-aos-delay="100"
    >
      <div class="card card-custom gutter-b">
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">
              Lista Negra
              <span class="d-block text-muted pt-2 font-size-sm"
                >Envio Documentos</span
              >
            </h3>
          </div>
          <div class="card-toolbar">
            <button
              @click="abirModalListaNegra(null, false)"
              class="btn btn-primary font-weight-bolder ml-5"
            >
              <i class="la la-plus"></i> Agregar Usuario
            </button>
          </div>
        </div>
        <div class="card-body">
          <!--begin: Search Form-->
          <!--begin::Search Form-->
          <div class="mb-7">
            <div class="row align-items-center">
              <div class="col-lg-9 col-xl-8">
                <div class="row align-items-center">
                  <div class="col-md-6 my-2 my-md-0">
                    <div class="input-icon">
                      <input
                        type="text"
                        class="form-control"
                        v-model="search"
                        placeholder="Buscar..."
                        id="kt_datatable_search_query"
                      />
                      <span>
                        <i class="flaticon2-search-1 text-muted"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::Search Form-->
          <!--begin: Datatable-->
          <v-data-table
            :headers="headers"
            :items="envioDocumentoListaNegras"
            :search="search"
            hide-default-footer
            :items-per-page="itemsPerPage"
            :page.sync="page"
            @page-count="pageCount = $event"
          >
            <template v-slot:item="row">
              <tr>
                <td>{{ row.item.rutEmpresa }}</td>
                <td>{{ row.item.email }}</td>
                <td class="d-flex">
                  <i
                    class="la la-edit cursor-pointer"
                    @click="abirModalListaNegra(row.item, true)"
                  ></i>
                  <i
                    class="la la-trash cursor-pointer ml-5"
                    @click="abrirModalEliminarListaNegra(row.item)"
                  ></i>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
          <!--end: Datatable-->
        </div>
      </div>
    </div>

    <b-modal
      id="modalCrearListaNegra"
      ref="modalCrearListaNegra"
      :title="editar ? 'Actualizar Lista Negra' : ' Nueva Lista Negra'"
      cancel-title="Cancelar"
      :ok-title="editar ? 'Actualizar' : 'Crear'"
      cancel-variant="light"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Rut Empresa"
          label-for="rutEmpresa-input"
          invalid-feedback="Rut es obligatorio"
          :state="rutEmpresaState"
        >
          <b-form-input
            type="text"
            placeholder="1111111-1"
            maxlength="10"
            required="true"
            class="form-control"
            id="rutEmpresa-input"
            v-model="$v.formListaNegra.rutEmpresa.$model"
            :state="validateState2('rutEmpresa')"
          ></b-form-input>
          <b-form-invalid-feedback
            v-if="!$v.formListaNegra.rutEmpresa.rutEsValido"
            id="rutEmpresa-input-live-feedback"
          >
            El Rut ingresado no es válido
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          label="Email"
          label-for="email-input"
          invalid-feedback="Email es obligatorio y debe ser un Email valido"
          :state="emailState"
        >
          <b-form-input
            id="email-input"
            v-model="$v.formListaNegra.email.$model"
            :state="validateState2('email')"
            required
          ></b-form-input>
          <b-form-invalid-feedback id="email-input-live-feedback">
          </b-form-invalid-feedback>
        </b-form-group>
      </form>
    </b-modal>

    <b-modal
      id="modalEliminarListaNegra"
      ref="modalEliminarListaNegra"
      title="Confirmar"
      cancel-title="Cancelar"
      ok-title="Si, Eliminar"
      cancel-variant="light"
      @ok="eliminarListaNegra"
    >
      Eliminar Lista Negra
    </b-modal>
  </div>
  <!--end::Dashboard-->
</template>


<script>
import { mapState } from "vuex";
import {
  GET_ENVIO_DOCUMENTO_LISTA_NEGRAS,
  CREATE_ENVIO_DOCUMENTO_LISTA_NEGRA,
  UPDATE_ENVIO_DOCUMENTO_LISTA_NEGRA,
  DELETE_ENVIO_DOCUMENTO_LISTA_NEGRA,
} from "@/core/services/store/envioDocumento.module";
import { validationMixin } from "vuelidate";

import {
  email,
  minLength,
  maxLength,
  required,
} from "vuelidate/lib/validators";
import { rutEsValido } from "@/core/validators/rut.js";
import moment from "moment";
moment.locale("es");

export default {
  mixins: [validationMixin],
  name: "dashboard",
  components: {
    /*Money,*/
  },
  data() {
    return {
      rutEmpresaState: null,
      emailState: null,
      dialog: false,
      tokenDelete: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      search: "",
      headers: [
        { text: "Rut Empresa", value: "rutEmpresa" },
        { text: "Email", value: "email" },
        { text: "Editar", value: "editar" },
      ],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "$ ",
        suffix: "",
        precision: 0,
        masked: false,
      },
      form: {
        documento: "",

        desde: "",
        hasta: "",
      },
      formListaNegra: {
        rutEmpresa: null,
        email: "",
      },

      editar: false,
      listaNegraSeleccionada: {},
    };
  },
  mounted() {
    this.getListaNegra();
  },
  validations: {
    form: {
      documento: {
        minLength: minLength(3),
      },
      desde: {},
      hasta: {},
    },
    formListaNegra: {
      rutEmpresa: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(100),
        rutEsValido,
      },
      email: { required, email, minLength: minLength(5) },
    },
  },
  methods: {
    abirModalListaNegra(item, editar) {
      this.listaNegraSeleccionada = item;
      this.rutEmpresa = "";
      this.email = "";

      this.$v.formListaNegra.rutEmpresa.$model = "";
      this.$v.formListaNegra.email.$model = "";
      this.editar = editar;

      if (editar) {
        this.$v.formListaNegra.rutEmpresa.$model = item.rutEmpresa;
        this.$v.formListaNegra.email.$model = item.email;
      }

      this.$bvModal.show("modalCrearListaNegra");
    },
    resetModal() {
      this.rutEmpresa = null;
      this.email = null;
    },
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.$v.formListaNegra.$touch();

      if (this.$v.formListaNegra.$anyError) {
        return;
      }
      this.handleSubmit();
    },
    handleSubmit() {
      const rutEmpresa = this.$v.formListaNegra.rutEmpresa.$model;
      const email = this.$v.formListaNegra.email.$model;

      if (this.editar == false) {
        this.$store
          .dispatch(CREATE_ENVIO_DOCUMENTO_LISTA_NEGRA, {
            rutEmpresa: rutEmpresa,
            email: email,
          })
          .then((data) => {
            if (data.statusCode == 201) {
              this.$bvToast.toast(`La lista se ha agregado correctamente`, {
                title: "Lista negra creada exitosamente",
                autoHideDelay: 5000,
                variant: "success",
                toaster: "b-toaster-top-right",
                appendToast: false,
              });
              this.$bvModal.hide("modalCrearListaNegra");
              this.getListaNegra();
            }
            if (data.statusCode == 208) {
              this.$bvToast.toast(`La lista ya existe`, {
                title: "Error",
                autoHideDelay: 5000,
                variant: "danger",
                toaster: "b-toaster-top-right",
                appendToast: false,
              });
            }

            if (data.statusCode == 202) {
              this.$bvToast.toast(
                `Error al crear la lista, intene nuevamente`,
                {
                  title: "Error",
                  autoHideDelay: 5000,
                  variant: "danger",
                  toaster: "b-toaster-top-right",
                  appendToast: false,
                }
              );
            }
          })
          .catch((e) => {
            this.$bvToast.toast(`${e.data.errors[0]}`, {
              title: "Error",
              autoHideDelay: 5000,
              variant: "danger",
              toaster: "b-toaster-top-right",
              appendToast: false,
            });
          });
      } else {
        this.$store
          .dispatch(UPDATE_ENVIO_DOCUMENTO_LISTA_NEGRA, {
            envioDocumentoListaNegraId:
              this.listaNegraSeleccionada.envioDocumentoListaNegraId,
            rutEmpresa,
            email,
          })
          .then((data) => {
            if (data.statusCode == 200) {
              this.$bvToast.toast(`La lista se ha actualizada correctamente`, {
                title: "lista actualizada",
                autoHideDelay: 5000,
                variant: "success",
                toaster: "b-toaster-top-right",
                appendToast: false,
              });
              this.$bvModal.hide("modalCrearListaNegra");
              this.getListaNegra();
            }
            if (data.statusCode == 208) {
              this.$bvToast.toast(`La lista ya existe`, {
                title: "Error",
                autoHideDelay: 5000,
                variant: "danger",
                toaster: "b-toaster-top-right",
                appendToast: false,
              });
            }
          })
          .catch((e) => {
            this.$bvToast.toast(`${e.data.errors[0]}`, {
              title: "Error",
              autoHideDelay: 5000,
              variant: "danger",
              toaster: "b-toaster-top-right",
              appendToast: false,
            });
          });
      }

      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },
    abrirModalEliminarListaNegra(listaNegra) {
      this.listaNegraSeleccionada = listaNegra;
      this.$bvModal.show("modalEliminarListaNegra");
    },
    eliminarListaNegra() {
      this.$store
        .dispatch(
          DELETE_ENVIO_DOCUMENTO_LISTA_NEGRA,
          this.listaNegraSeleccionada.envioDocumentoListaNegraId
        )
        .then((data) => {
          if (data.statusCode == 200) {
            this.$bvToast.toast(`Lista negra eliminada`, {
              title: "Lista negra eliminada exitosamente",
              autoHideDelay: 5000,
              variant: "success",
              toaster: "b-toaster-top-right",
              appendToast: false,
            });
            this.$bvModal.hide("modalEliminarListaNegra");
          }
          this.getListaNegra();
        })
        .catch((e) => {
          this.$bvToast.toast(`${e.data.errors[0]}`, {
            title: "Error",
            autoHideDelay: 5000,
            variant: "danger",
            toaster: "b-toaster-top-right",
            appendToast: false,
          });
        });
    },
    validateState2(name) {
      const { $dirty, $error } = this.$v.formListaNegra[name];
      return $dirty ? !$error : null;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    getListaNegra() {
      this.$Progress.start();
      this.$store.dispatch(GET_ENVIO_DOCUMENTO_LISTA_NEGRAS, null).then(() => {
        this.$Progress.finish();
      });
    },
  },
  computed: {
    ...mapState({
      envioDocumentoListaNegras: (state) =>
        state.envioDocumento.envioDocumentoListaNegras,
      errors: (state) => state.errors,
    }),
  },
};
</script>
<style>
.container {
  max-width: 1185px !important;
}

.d-content-full {
  width: 100%;
}

.v-data-table .btn,
.card-toolbar .btn {
  border-radius: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  padding: 7px 20px 6px 20px;
  text-transform: uppercase;
}

.card.card-custom > .card-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  min-height: 70px;
  padding-top: 0;
  padding-bottom: 0;
  background-color: transparent;
}

.card-header:first-child {
  border-radius: calc(0.42rem - 1px) calc(0.42rem - 1px) 0 0;
}
.pt-6,
.py-6 {
  padding-top: 1.5rem !important;
}
.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}
.flex-wrap {
  -ms-flex-wrap: wrap !important;
  flex-wrap: wrap !important;
}
.border-0 {
  border: 0 !important;
}
.card-header {
  padding: 2rem 2.25rem;
  margin-bottom: 0;
  background-color: #ffffff;
  border-bottom: 1px solid #ebedf3;
}
.btn.btn-primary {
  color: #ffffff;
  background-color: #3699ff;
  border-color: #3699ff;
}
.btn:not(.btn-text) {
  cursor: pointer;
}
.btn {
  outline: none !important;
  vertical-align: middle;
  -webkit-transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
  transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
  transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, box-shadow 0.15s ease;
  transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, box-shadow 0.15s ease,
    -webkit-box-shadow 0.15s ease;
}
.font-weight-bolder {
  font-weight: 600 !important;
}
.btn-primary {
  color: #ffffff;
  background-color: #3699ff;
  border-color: #3699ff;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
